import React from 'react';

interface ButtonProps {
    children: React.ReactNode;
    onClick?: () => void;
    type?: 'button' | 'submit' | 'reset';
    className?: string;
    disabled?: boolean;
    variant?: 'primary' | 'secondary' | 'danger' | 'outline'; // Add outline variant
}

const Button: React.FC<ButtonProps> = ({ children, onClick, type = 'button', className = '', disabled = false, variant = 'primary' }) => {
    const baseClasses = 'px-4 py-2 rounded-lg focus:ring-2 focus:ring-opacity-50 disabled:bg-gray-400 disabled:cursor-not-allowed';
    const variantClasses = {
        primary: 'bg-blue-500 text-white hover:bg-blue-600 focus:ring-blue-500',
        secondary: 'bg-gray-500 text-white hover:bg-gray-600 focus:ring-gray-500',
        danger: 'bg-red-500 text-white hover:bg-red-600 focus:ring-red-500',
        outline: 'bg-transparent border border-gray-500 text-gray-500 hover:bg-gray-100 focus:ring-gray-500',
    };

    return (
        <button
            type={type}
            onClick={onClick}
            className={`${baseClasses} ${variantClasses[variant]} ${className}`}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

export default Button;